import React from 'react';
const ConfigContext = /*#__PURE__*/React.createContext({});
export default ConfigContext;